import { Badge } from "@/components/ui/badge";
import { ChevronDown, ChevronRight } from "lucide-react";
import { DateTime } from "luxon";
import { useState } from "react";

const CallTimeline = ({ call }) => {
    const [isTimelineExpanded, setIsTimelineExpanded] = useState(false);
    const { 
        call_logs: callLogs = [],
        community = {},
        prospect = {},
    } = call;

    const formatName = ({first_name: firstName, last_name: lastName}) => {
        const capitalize = (str) => {
            if (!str || typeof str !== 'string') return '';
            return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
        };

        return `${capitalize(firstName)} ${capitalize(lastName)}`
    }

    const formatPhoneNumber = (phone) => {
        if (!phone) {
            return '';
        }

        const digits = phone.replace(/\D/g, '').slice(-10); // Keep last 10 digits

        if (digits.length !== 10) {
            return phone;
        }
        const [, area, prefix, line] = digits.match(/(\d{3})(\d{3})(\d{4})/) || [];

        return `(${area}) ${prefix}-${line}`;
    };

    const renderPhoneNumber = (phoneNumber) => {
        if (!phoneNumber) return '-';
        let displayText;
        if (phoneNumber === community?.community_phone_number) {
            displayText = community.community_name;
        } else if (phoneNumber === prospect?.phone_number) {
            displayText = prospect.first_name?.trim()
                ? formatName(prospect)
                : formatPhoneNumber(prospect.phone_number)
        } else if (phoneNumber === community?.assigned_flair_phone_number) {
            displayText = 'Flair';
        } else {
            displayText = formatPhoneNumber(phoneNumber);
        }
        return (
            <Badge variant="secondary" className="font-normal">
                {displayText}
            </Badge>
        );
    }

    return (
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4" >
            <button
                onClick={() => setIsTimelineExpanded(!isTimelineExpanded)}
                className="flex items-center justify-between w-full text-left focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 rounded"
                aria-expanded={isTimelineExpanded}
            >
                <h2 className="text-sm font-semibold text-gray-900">Call Timeline</h2>
                {isTimelineExpanded ? <ChevronDown size={16} /> : <ChevronRight size={16} />}
            </button>

            {
                isTimelineExpanded && (
                    <div className="mt-4 overflow-x-auto">
                        <table className="w-full">
                            <thead>
                                <tr className="border-b border-gray-100">
                                    <th className="text-left text-xs font-medium text-gray-500 uppercase tracking-wide py-2">From</th>
                                    <th className="text-left text-xs font-medium text-gray-500 uppercase tracking-wide py-2">To</th>
                                    <th className="text-left text-xs font-medium text-gray-500 uppercase tracking-wide py-2">
                                        Status
                                    </th>
                                    <th className="text-left text-xs font-medium text-gray-500 uppercase tracking-wide py-2">
                                        Timestamp
                                    </th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-50">
                                {callLogs?.map((log, index) => (
                                    <tr key={index} className="hover:bg-gray-50">
                                        <td className="py-2 text-sm text-gray-700">{renderPhoneNumber(log.from_number)}</td>
                                        <td className="py-2 text-sm text-gray-700">{renderPhoneNumber(log.to_number)}</td>
                                        <td className="py-2 text-sm text-gray-700">{log.status}</td>
                                        <td className="py-2 text-sm text-gray-500 font-mono">{DateTime.fromISO(log.timestamp).setZone(community?.time_zone).toFormat('hh:mm:ss a')}</td>
                                        <td className="py-2 text-sm text-gray-500 font-mono">{log.duration}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )
            }
        </div >
    )
}

export default CallTimeline;